;(function($, window, document){
    window.InfiniteLoadListing = Me.view.extend({
        options: {
        },

        initialize: function() {
            _.bindAll(this, 'loadMoreHandler');
            this.addEvents();
        },
        addEvents: function() {
            Me.dispatch.subscribe('LOAD_MORE.SUCCESS', this.loadMoreHandler);
        },
        loadMoreHandler: function(e, params){

            var view = this;

            console.log($(params.data).attr('data-nextpage'));
            if($(params.data).attr('data-nextpage')){
                $('.listing-sections').attr('data-nextpage', $(params.data).attr('data-nextpage'));
            }else{
                $('.load-more').addClass('hide');
            }
            $(params.data).find('>section').each(function(index,value){
                view.$el.append(value);
            })
        }
    });
}(jQuery, window, document));
